import { render, staticRenderFns } from "./LayoutGridSystem.vue?vue&type=template&id=53456fb0&scoped=true&"
import script from "./LayoutGridSystem.vue?vue&type=script&lang=js&"
export * from "./LayoutGridSystem.vue?vue&type=script&lang=js&"
import style0 from "./LayoutGridSystem.vue?vue&type=style&index=0&id=53456fb0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53456fb0",
  null
  
)

export default component.exports